import { render, staticRenderFns } from "./regional-competitiveness.vue?vue&type=template&id=04ea3efb&scoped=true&"
import script from "./regional-competitiveness.vue?vue&type=script&lang=js&"
export * from "./regional-competitiveness.vue?vue&type=script&lang=js&"
import style0 from "./regional-competitiveness.vue?vue&type=style&index=0&id=04ea3efb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea3efb",
  null
  
)

export default component.exports